export default __webpack_public_path__ + "static/media/Touch-App-Geraeteabbildung_ULTRAMAT_6_2_675x267px.14900527.png";